module.exports = [
    "mahir@molai.dev",
    "therealhackermon@gmail.com",
    "jj@jj.is-a.dev",
    "phenax5@gmail.com",
    "andrew@win11react.com",
    "maskduck@proton.me"
]
